<nav class="sidemenu-panel d-flex flex-column" [class.expanded]="expanded()" (mouseleave)="scheduleClose()">
    <div class="menu-entry has-submenu" [class.open]="openKey() === 'profile'" (pointerenter)="onEntryEnter('profile', $event)">
        <a
            href="javascript:void(0)"
            class="menu-link d-flex align-items-center py-2 text-decoration-none text-body text-nowrap"
            (click)="onEntryTap('profile', $event)"
        >
            <span class="menu-icon d-flex align-items-center justify-content-center"><i class="bi-person-circle fs-3"></i></span>
            <span class="menu-label flex-fill" title="{{ applicationContextStore.displayName() }}">{{ applicationContextStore.displayName() }}</span>
            <i class="bi bi-chevron-right submenu-caret"></i>
        </a>
        <div class="submenu">
            <ul class="submenu-list list-unstyled m-0 overflow-hidden">
                @if (!applicationContextStore.isSingleBranchUser()) {
                    <li>
                        <a class="nav-link" href="javascript:void(0)" (click)="openBranchSelectModal()">
                            {{ applicationContextStore.branch().name }}
                        </a>
                    </li>
                }
                @if (hasTimeClockFeature()) {
                    <li>
                        @if (applicationContextStore.isLoadingWorkDayClockStatus()) {
                            <span class="nav-link d-flex align-items-center">
                                <span class="spinner-border spinner-border-sm text-primary me-2" role="status">
                                    <span class="visually-hidden">
                                        {{ { feature: "Common", component: "Menu", label: "Loading" } | translate }}...
                                    </span>
                                </span>
                                {{ { feature: "Common", component: "Menu", label: "Loading" } | translate }}...
                            </span>
                        } @else {
                            <a class="nav-link" href="javascript:void(0)" (click)="toggleClockStatus()">
                                @if (applicationContextStore.isWorkDayClockedIn()) {
                                    <i class="bi bi-clock-fill text-danger me-2"></i>
                                    {{ { feature: "Common", component: "Menu", label: "Clock Out" } | translate }}
                                } @else {
                                    <i class="bi bi-clock-fill text-success me-2"></i>
                                    {{ { feature: "Common", component: "Menu", label: "Clock In" } | translate }}
                                }
                            </a>
                        }
                    </li>
                }
                <li>
                    <a class="nav-link" href="javascript:void(0)" (click)="openLanguageModal()">
                        {{ { feature: "Common", component: "Menu", label: "Change Language" } | translate }}
                        ({{ applicationContextStore.selectedLanguage().id }})
                    </a>
                </li>
                @if (canSignOut) {
                    <li>
                        <a class="nav-link" href="javascript:void(0)" (click)="logout()">
                            {{ { feature: "Common", component: "Menu", label: "Logout" } | translate }}
                        </a>
                    </li>
                }
            </ul>
        </div>
    </div>

    <ul class="nav nav-pills flex-column w-100">
        @for (item of visibleMenuItems(); track item.text) {
            <li class="menu-entry border-top w-100" [class.has-submenu]="(item.children?.length ?? 0) > 0" [class.open]="openKey() === item.text" (pointerenter)="onEntryEnter(item.text, $event)">
                @if ((item.children?.length ?? 0) > 0) {
                    <a class="menu-link d-flex align-items-center py-2 text-decoration-none text-body text-nowrap" href="javascript:void(0)" title="{{ item.text }}" (click)="onEntryTap(item.text, $event)">
                        <span class="menu-icon d-flex align-items-center justify-content-center"><i [class]="item.iconClass"></i></span>
                        <span class="menu-label flex-fill">{{ item.text }}</span>
                        <i class="bi bi-chevron-right submenu-caret"></i>
                    </a>
                    <div class="submenu">
                        <ul class="submenu-list list-unstyled m-0 overflow-hidden">
                            @for (subItem of item.children; track $index) {
                                @if ((subItem.children?.length ?? 0) > 0) {
                                    <li>
                                        <span class="nav-link submenu-group-label">{{ subItem.text }}</span>
                                        <ul class="submenu-list submenu-list-nested list-unstyled m-0 overflow-hidden">
                                            @for (leaf of subItem.children; track $index) {
                                                <li>
                                                    <a
                                                        class="nav-link"
                                                        [routerLink]="leaf.route"
                                                        routerLinkActive="active"
                                                        [routerLinkActiveOptions]="{ exact: true }"
                                                    >
                                                        {{ leaf.text }}
                                                    </a>
                                                </li>
                                            }
                                        </ul>
                                    </li>
                                } @else {
                                    <li>
                                        <a
                                            class="nav-link"
                                            [routerLink]="subItem.route"
                                            routerLinkActive="active"
                                            [routerLinkActiveOptions]="{ exact: true }"
                                        >
                                            {{ subItem.text }}
                                        </a>
                                    </li>
                                }
                            }
                        </ul>
                    </div>
                } @else {
                    <a
                        class="menu-link d-flex align-items-center py-2 text-decoration-none text-body text-nowrap"
                        [routerLink]="item.route"
                        routerLinkActive="active"
                        title="{{ item.text }}"
                    >
                        <span class="menu-icon d-flex align-items-center justify-content-center"><i [class]="item.iconClass"></i></span>
                        <span class="menu-label flex-fill">{{ item.text }}</span>
                    </a>
                }
            </li>
        }
    </ul>
</nav>
